"use strict";
/**
 * Swiper carousel conditional loading
 * Only loads Swiper if elements with .swiper class exist on the page
 *
 * @package StandOut
 * @since 2.0.0
 */
document.addEventListener("DOMContentLoaded", () => {
    const swiperElements = document.getElementsByClassName("swiper");
    if (swiperElements.length > 0) {
        Promise.all([import("swiper"), import("swiper/css")])
            .then(([{ Swiper }]) => {
            globalThis.Swiper = Swiper;
            const event = new CustomEvent("swiper-loaded", {
                bubbles: true,
            });
            window.dispatchEvent(event);
        })
            .catch((error) => {
            console.error("Failed to load Swiper:", error);
        });
    }
});
